import { Component, Input } from '@angular/core';
import { concat, Subject, toArray } from 'rxjs';
import {
  IPolicyDetail,
  Uni30Estemporaneo,
} from 'src/app/modules/shared/models/policy.model';
import { PolicyService } from '../../policy.service';

@Component({
  selector: 'app-policy-estemporanei',
  templateUrl: './policy-estemporanei.component.html',
  styleUrl: './policy-estemporanei.component.scss',
})
export class PolicyEstemporaneiComponent {
  @Input() detail: IPolicyDetail;
  destroy$ = new Subject<void>();
  estemporaneiDetails: any[];

  constructor(private _policyService: PolicyService) {}

  ngOnInit() {
    this.getFondo();
  }

  getFondo(): void {
    const observables = this.detail.intesaFurtherDetails.uni30.estemporanei
      .map((x) => x.fundCode)
      .map((x) =>
        this._policyService.getFondo(
          this.detail.policyExtraInfo.contractNumber,
          x
        )
      );
    concat(...observables)
      .pipe(toArray())
      .subscribe((responses) => {
        this.estemporaneiDetails = responses.map((response) => {
          const estemporaneoPolicyDetail: Uni30Estemporaneo =
            this.detail.intesaFurtherDetails.uni30.estemporanei.find(
              (x) => x.fundCode === response.cFondo
            );

          return {
            effectDate: estemporaneoPolicyDetail.effectDate,
            fundName: response.descrizione,
            percentage: estemporaneoPolicyDetail.percentage,
          };
        });
      });
  }
}
